<template>
  <div>
    <slot name="loading">
      <i v-if="loading" class="fa fa-spinner fa-spin"></i>
    </slot>
    <slot></slot>
    <div>
      <b-list-group>
        <b-list-group-item v-for="(item, index) in updates_list" v-bind:key="item.id">
          <i class="fa fa-check-square"></i>
          <router-link
            :to="{
              name: 'Gestión de Siniestros',
              params: { siniestro: item.erp_id },
            }"
          >
            <b-badge
              >{{ item.fecha_gestion }} - Siniestro
              {{ item.erp_id }}</b-badge
            > </router-link
          ><br />Actualización del usuario <b>{{ item.usuario }}</b>:<br />{{
            item.descripcion
          }}. {{ item.observaciones }}
        </b-list-group-item>
      </b-list-group>
    </div>
    <br/>
    <moon-loader
      :loading="loadingTable"
      color="green"
      size="150px"
    ></moon-loader>
    <b-button class="mr-1" size="sm" variant="success" @click="setMoreClaims()"> <i class="fa fa-search"></i> Ver más </b-button>
    <hr />
  </div>
</template>
<script>
import { insuranceClaimsService } from "@/src/../_services";
import MoonLoader from "vue-spinner/src/MoonLoader.vue";

export default {
  name: "UltimasActualizaciones",
  props: {
    loading: Boolean,
    disabled: Boolean,
  },
  components: {
    MoonLoader: MoonLoader,
  },
  data() {
    return {
      updates_list: [],
      datos: "",
      loadingTable: true,
      numSiniestros: 5,
    };
  },
  async mounted() {
    this.loadingTable = true;
    this.updates_list = await insuranceClaimsService.getNLastClaimLog(this.numSiniestros);
    this.loadingTable = false;
  },
  methods: {
    async setMoreClaims() {
      this.loadingTable = true;
      this.numSiniestros += 5;
      this.updates_list = await insuranceClaimsService.getNLastClaimLog(this.numSiniestros);
      this.loadingTable = false;
    }
  },
};
</script>
<style>
</style>
